// extracted by mini-css-extract-plugin
module.exports = {"root":"IframeWrapper_root__1b_PC","loadingContainer":"IframeWrapper_loadingContainer__2DYBE","container":"IframeWrapper_container__278Tp"};